import React from 'react';
import { toast } from 'sonner';
import { VisualContextMenu } from './VisualContextMenu';

const RICH_TEXT_PLACEHOLDERS = [
  { label: 'Page Number', value: '{{page}}' },
  { label: 'Total Pages', value: '{{total_pages}}' },
  { label: 'Date', value: '{{date}}' },
  { label: 'Time', value: '{{time}}' },
  { label: 'Report Name', value: '{{report_name}}' },
  { label: 'Printed By', value: '{{user}}' },
];

/**
 * Wires the right-click context menu for a visual on the report-builder canvas.
 * Owns the move-to-front/back, delete, duplicate, alert, promote-to-library, and
 * (in report mode for rich_text visuals) placeholder-insertion handlers.
 *
 * Renders nothing when `visualCtxMenu` is null.
 */
export function VisualContextMenuWrapper({
  visualCtxMenu, setVisualCtxMenu,
  visuals, designerMode,
  reportId, api,
  setLibraryVisuals,
  updateVisual,
  handleZIndexChange, handleDeleteFromCtx, handleDuplicateFromCtx, handleCreateAlertFromViz,
}) {
  if (!visualCtxMenu) return null;

  const ctxVisual = visuals.find(v => v.id === visualCtxMenu.vizId);
  const isTextInReportMode = designerMode === 'report' && ctxVisual?.vizType === 'rich_text';
  const placeholderItems = isTextInReportMode ? RICH_TEXT_PLACEHOLDERS : [];

  const onPromoteToLibrary = reportId ? async () => {
    try {
      const lib = await api.promoteToLibrary({ report_id: reportId, visual_id: visualCtxMenu.vizId });
      updateVisual(visualCtxMenu.vizId, { library_visual_id: lib.visual_id });
      setLibraryVisuals(prev => [lib, ...prev]);
      toast.success(`"${ctxVisual?.title || 'Visual'}" saved to library`);
    } catch (err) { toast.error(err.message); }
    setVisualCtxMenu(null);
  } : undefined;

  const onInsertPlaceholder = isTextInReportMode ? (val) => {
    if (ctxVisual) updateVisual(visualCtxMenu.vizId, { textContent: (ctxVisual.textContent || '') + val });
    setVisualCtxMenu(null);
  } : undefined;

  return (
    <VisualContextMenu
      x={visualCtxMenu.x}
      y={visualCtxMenu.y}
      onClose={() => setVisualCtxMenu(null)}
      onMoveToFront={() => handleZIndexChange('front')}
      onMoveToBack={() => handleZIndexChange('back')}
      onMoveForward={() => handleZIndexChange('forward')}
      onMoveBackward={() => handleZIndexChange('backward')}
      onDelete={handleDeleteFromCtx}
      onDuplicate={handleDuplicateFromCtx}
      onCreateAlert={handleCreateAlertFromViz}
      isLinked={!!ctxVisual?.library_visual_id}
      onPromoteToLibrary={onPromoteToLibrary}
      placeholders={placeholderItems}
      onInsertPlaceholder={onInsertPlaceholder}
    />
  );
}
